// eslint-disable-next-line eslint-comments/disable-enable-pair -- Ignore
/* eslint-disable react/no-array-index-key -- Ignore */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useIntl } from 'react-intl';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import { SelectCustom, SelectCustomOption } from '@americanexpress/dls-react';
import clsx from 'clsx';
import generateChildAgeDropdownOptions from '../../utils/childAgeDropdownOptionsUtil';
import { useRoomsContext } from '../../contexts/roomsContext';
import {
  hasChildAgeBelowTwoRule,
  hasZeroAndOneAgeLabelsRule,
  isChildrenMaxAgeElevenRule,
} from '../../constants/featureConstants';
import { useConfigContext } from '../../contexts/configContext';
import NotesSection from '../NotesSection/NotesSection';
import styles from './Infants.scss';

const ChildrenAgesVariant = ({
  hasChildAgeBelowTwo,
  hasMaxAgeOfEleven,
  hasZeroAndOneAgeLabels,
  isMultiRoom,
  roomIndex,
}) => {
  const { rooms, updateChildAge } = useRoomsContext();
  const { moduleId, hasInfants } = useConfigContext();

  const { formatMessage } = useIntl();
  const { children } = rooms[roomIndex];

  const childAgeDropdownOptions = generateChildAgeDropdownOptions({
    hasMaxAgeOfEleven,
    hasInfants,
    hasZeroAndOneAgeLabels,
    hasChildAgeBelowTwo,
  });

  const roomId = roomIndex + 1;
  return (
    <div className="margin-1-b">
      <NotesSection id="child_age_at_end_of_travel" />
      <div className="row pad-1-lr">
        {children.map((age, childIndex) => {
          const childId = childIndex + 1;
          const labelHtmlFor = `${moduleId}-room-${roomId}-child-${childId}-age`;
          return (
            <div key={`${roomIndex}_${childIndex}`} className="col-xs-6 pad-0 pad-1-lr">
              <div className="form-group">
                <SelectCustom
                  id={labelHtmlFor}
                  status="default"
                  label={formatMessage({ id: 'child_age' },
                    { totalChildren: children.length, childIndex: childId })}
                  value={age}
                  onValueChange={(childAge) => updateChildAge(roomIndex, childIndex, childAge)}
                  aria-describedby="childAgeAtEndOfTravel"
                  className={clsx(styles.noWrapButton, 'margin-1-b')}
                >
                  {childAgeDropdownOptions.map((item) => (
                    <SelectCustomOption
                      aria-label={formatMessage(
                        { id: 'roomChildAgeAriaLabel' },
                        {
                          isMultiRoom,
                          roomId,
                          childId,
                          childAge: item.value,
                        }
                      )}
                      key={item.value}
                      value={item.value}
                      className="dls-bright-blue"
                    >
                      {item.label}
                    </SelectCustomOption>
                  ))}
                </SelectCustom>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

ChildrenAgesVariant.propTypes = {
  hasChildAgeBelowTwo: PropTypes.bool.isRequired,
  hasMaxAgeOfEleven: PropTypes.bool.isRequired,
  hasZeroAndOneAgeLabels: PropTypes.bool.isRequired,
  isMultiRoom: PropTypes.bool,
  roomIndex: PropTypes.number,
};

ChildrenAgesVariant.defaultProps = {
  roomIndex: 0,
};

const mapFeaturesToProps = {
  hasChildAgeBelowTwo: hasChildAgeBelowTwoRule,
  hasMaxAgeOfEleven: isChildrenMaxAgeElevenRule,
  hasZeroAndOneAgeLabels: hasZeroAndOneAgeLabelsRule,
};
const hocChain = compose(withConditionalFeatures({ mapFeaturesToProps }));

export { ChildrenAgesVariant as TestableChildrenAges };

export default hocChain(ChildrenAgesVariant);
